import axios from 'axios'
import { API_URL } from '@/const'
import { getHistoryMsg } from '../../func'
import { store } from '@/store'
export const getAxiosMsgBroadcastById = async (id, setStateChatList) => {
  try {
    const { accessToken } = store.state.app.user
    const headers = {
      Authorization: `Bearer ${accessToken}`
    }
    const { data } = await axios.get(`${API_URL.MESSAGES}/${id}`, { headers })
    if (!data) return {}
    if (data.length === 0) return {}
    let chatList = getHistoryMsg(data)
    setStateChatList(chatList)
  } catch (e) {
    console.log(e.response.data)
  }
}
